import { useState, useEffect } from 'react';
import { FormTab, TabbedForm, useRecordContext } from 'react-admin';
import { useWatch } from 'react-hook-form';
import { MainTab } from './MainTab';
import { TuneTab } from './TuneTab';
import { TrackCBTab } from './TrackCBTab';
import { ClicksTab } from './ClicksTab';
import { GoogleConversionsGoalsTab } from './GoogleConversionsGoalsTab';
import { CustomEditToolbar } from '../../../../helperComponents/CustomEditToolbar';
import { PLATFORM_TYPES } from '../../../../../config/constants/apiConstants';

const PlatformTypeWatcher = ({ onChange }) => {
  const platformType = useWatch({ name: 'platform_type' });

  useEffect(() => {
    onChange(platformType === PLATFORM_TYPES.GOOGLE);
  }, [platformType, onChange]);

  return null;
};

export const MediaPlatformSettingsTabs = ({ isEdit }) => {
  const record = useRecordContext();
  const [isGoogle, setIsGoogle] = useState(
    record?.platform_type === PLATFORM_TYPES.GOOGLE
  );

  if (!record) return null;

  return (
    <TabbedForm toolbar={<CustomEditToolbar alwaysEnable={true} />}>
      <FormTab label="Main">
        <PlatformTypeWatcher onChange={setIsGoogle} />
        <MainTab isEdit={isEdit} />
      </FormTab>
      <FormTab label="Tune">
        <TuneTab />
      </FormTab>
      <FormTab label="TrackCB">
        <TrackCBTab />
      </FormTab>
      {!isGoogle && (
        <FormTab label="Clicks">
          <ClicksTab />
        </FormTab>
      )}
      {isGoogle && (
        <FormTab label="Conversions Goals">
          <GoogleConversionsGoalsTab />
        </FormTab>
      )}
    </TabbedForm>
  );
};
